import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, DollarSign, Award, ThumbsUp } from 'lucide-react';
const results = [{
  icon: Award,
  title: 'Produtos com aparência profissional',
  description: 'Seu trabalho passa a ser visto como "de loja" e não apenas "feito em casa".'
}, {
  icon: ThumbsUp,
  title: 'Mais valor percebido',
  description: 'O cliente olha e entende imediatamente porque seu produto vale mais.'
}, {
  icon: DollarSign,
  title: 'Preços mais altos',
  description: 'Facilidade para justificar e cobrar o valor que seu trabalho realmente merece.'
}, {
  icon: TrendingUp,
  title: 'Diferenciação no mercado',
  description: 'Saia da guerra de preços e destaque-se pela qualidade e sofisticação.'
}];
export function FuturePacingSection() {
  return <section className="py-10 md:py-16 bg-gradient-to-br from-amber-50 via-yellow-50 to-stone-50" data-id="element-65">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-12" data-id="element-67">
          <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-stone-900 mb-6" data-id="element-68">
            O que muda quando você aplica o Efeito Boutique™
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-69">
          {results.map((result, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-white p-4 rounded-lg shadow-lg border-b-4 border-amber-400" data-id="element-70">
              <div className="bg-stone-50 w-10 h-10 rounded-full flex items-center justify-center mb-3 mx-auto" data-id="element-71">
                <result.icon className="w-5 h-5 text-amber-600" data-id="element-72" />
              </div>
              <h3 className="text-base font-bold text-stone-900 mb-1.5 text-center" data-id="element-73">
                {result.title}
              </h3>
              <p className="text-stone-600 text-center text-sm leading-relaxed" data-id="element-74">
                {result.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}